import { createContext } from "react";
export var initialState = {
    theme: 'light',
    mode: 'light',
    // tslint:disable-next-line:no-empty
    setMode: function () { },
    componentMounted: false,
};
export var ThemeContext = createContext(initialState);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWVDb250ZXh0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGhlbWVDb250ZXh0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFZdEMsTUFBTSxDQUFDLElBQU0sWUFBWSxHQUFrQjtJQUN6QyxLQUFLLEVBQUUsT0FBTztJQUNkLElBQUksRUFBRSxPQUFPO0lBQ2Isb0NBQW9DO0lBQ3BDLE9BQU8sRUFBRSxjQUFPLENBQUM7SUFDakIsZ0JBQWdCLEVBQUUsS0FBSztDQUN4QixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sWUFBWSxHQUFHLGFBQWEsQ0FBQyxZQUFZLENBQUMsQ0FBQyJ9